import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home/home-component'
import About from '@/components/about/about-component'
import Work from '@/components/work/work-component'
import Legal from '@/components/legal/legal-component'
// import Pro from '@/components/pro/pro-component'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/work',
      name: 'work',
      component: Work
    },
    {
      path: '/legal',
      name: 'legal',
      component: Legal
    }
    /*,
        {
          path: '/pro',
          name: 'pro',
          component: Pro
        } */
  ],
  mode: 'history'
})


// WEBPACK FOOTER //
// ./src/router/index.js